<script>
	export let message;
	let dismissed = false;

	$: if (message) {
		dismissed = false;
	}

	const emailRegex = /([^\s@]+@[^\s@]+\.[^\s@]+)/;

	$: parts = message ? message.split(emailRegex) : [];
</script>

{#if message && !dismissed}
	<div class="success-banner" role="alert">
		<div class="success-banner__inner">
			<svg
				class="success-banner__icon"
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				aria-hidden="true"
			>
				<circle cx="12" cy="12" r="12" fill="#2E7D32" />
				<path
					d="M7 12.5l3.5 3.5 6.5-7"
					stroke="#fff"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<span class="success-banner__text">
				{#each parts as part}
					{#if emailRegex.test(part)}
						<strong>{part}</strong>
					{:else}
						{part}
					{/if}
				{/each}
			</span>
		</div>
		<button
			class="success-banner__close"
			type="button"
			on:click={() => (dismissed = true)}
		>
			<span class="visually-hidden">Close</span>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="currentColor"
				role="img"
				aria-hidden="true"
			>
				<path
					d="M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293A1 1 0 0 1 .293 14.707L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z"
				/>
			</svg>
		</button>
	</div>
{/if}

<style>
	.success-banner {
		display: flex;
		align-items: center;
		gap: 8px;
		background: var(--schemes-success-container, #e9f3ec);
		border-radius: 8px;
		padding: 16px;
		width: 100%;
		box-sizing: border-box;
	}

	.success-banner__inner {
		display: flex;
		align-items: center;
		gap: 16px;
		flex: 1 0 0;
		min-width: 0;
	}

	.success-banner__icon {
		flex-shrink: 0;
	}

	.success-banner__text {
		color: var(--schemes-on-surface-container, #00071f);
		font-family: "DM Sans", sans-serif;
		font-size: 14px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.01px;
	}

	.success-banner__close {
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		color: var(--schemes-on-surface-container, #00071f);
		display: flex;
		align-items: center;
		flex-shrink: 0;
		opacity: 0.6;
	}

	.success-banner__close:hover {
		opacity: 1;
	}
</style>
